export default __webpack_public_path__ + "static/car_insurance_products-a234d8bb36285179cf2c1e275d077b3b.webp";